import PackageForm from "@/features/packages/components/PackageForm";
import { usePackages } from "@/features/packages/hooks/usePackages";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import HeadLayout from "@shared/layouts/HeadLayout";
import { PACKAGE_TOAST_KEYS, PACKAGE_ROUTES } from "../constants";

const CreatePackage = () => {
  const { t } = useTranslation();
  const { createPackage, createPackageLoading } = usePackages();
  const navigate = useNavigate();
  const handleSubmit = (data) => {
    const toastId = toast.loading(t(PACKAGE_TOAST_KEYS.CREATING));
    createPackage(data, {
      onSuccess: () => {
        toast.success(`Package created ${data.customer.name}`, {
          id: toastId,
        });
        // navigate(PACKAGE_ROUTES.LIST);
      },
      onError: (error) => {
        toast.error(`${error.response.data.message}`, {
          id: toastId,
        });
      },
    });
  };

  return (
    <>
      <HeadLayout title={t("packages.addPackage")} />
      <PackageForm
        onSubmit={handleSubmit}
        action={"create"}
        actionIsLoading={createPackageLoading}
      />
    </>
  );
};

export default CreatePackage;
